"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateAndTime = void 0;
const react_1 = __importDefault(require("react"));
const i18n_1 = require("@app/util/i18n");
const moment_1 = __importDefault(require("moment"));
const DateAndTime = ({ details }) => {
    const _getStartTimeStr = (s) => {
        const h = Math.floor((s ?? 0));
        const m = Math.floor(((s ?? 1) % 1) * 60);
        return h.toString() + (0, i18n_1.t)('HOUR_SHORT') + (m > 0 ? ' ' + m.toString() + (0, i18n_1.t)('MINUTE_SHORT') : '');
    };
    return (react_1.default.createElement("div", { className: 'ds-viewshift-row' },
        react_1.default.createElement("div", { className: 'ds-viewshift-col-label' }, (0, i18n_1.t)('VIEW_SHIFT_SHIFT')),
        react_1.default.createElement("div", { className: 'ds-viewshift-col-value', style: { display: 'block' } },
            react_1.default.createElement("div", { className: 'ds-vsr-time' }, details.period ? ((0, moment_1.default)(details.period.start).format('dddd D.M.YYYY - H:mm - ') + (0, moment_1.default)(details.period.end).format('H:mm')) : null),
            react_1.default.createElement("div", { className: 'ds-vsr-duration' }, details.period
                ? ' (' + (0, i18n_1.t)('VIEW_SHIFT_LEN') + ' ' + _getStartTimeStr((0, moment_1.default)(((0, moment_1.default)(details.period.end).format('HH:mm') > (0, moment_1.default)(details.period.start).format('HH:mm')
                    ? (0, moment_1.default)((0, moment_1.default)(details.period.start).format('YYYY-MM-DD') + 'T' + (0, moment_1.default)(details.period.end).format('HH:mm:ss'))
                    : (0, moment_1.default)((0, moment_1.default)(details.period.start).format('YYYY-MM-DD') + 'T' + (0, moment_1.default)(details.period.end).format('HH:mm:ss')).add(1, 'day'))).diff(details.period.start, 'minutes') / 60) + ')' : null))));
};
exports.DateAndTime = DateAndTime;
